import { SemanticUI } from '@iterable/deprecated_react_components';
import { FormField } from 'ui/formField';
import { Label, IconLabel, IconContainer } from './customWidgetSettings.styled';

// type Props = {
//   /** Callback function when value is changed. */
//   onChange: () => void,
//   settings: {},
//   /** Value of the trendDirection */
//   value: string,
// };

const trendDirections = {
  UP: 'up',
  DOWN: 'down',
  CUSTOMTREND: 'customTrend',
  CUSTOMRANGE: 'customRange',
};

const TrendDirection = ({
  onChange,
  settings = { trendColors: {} },
  value = trendDirections.UP,
}) => {
  const trendColors = settings && settings.trendColors ? settings.trendColors : {};
  return (
    <div>
      <FormField>
        <SemanticUI.Radio
          label={
            <Label>
              <IconContainer $isPositiveColor>
                <SemanticUI.Icon name="arrow up" />
              </IconContainer>
              <IconContainer>
                <SemanticUI.Icon name="arrow down" />
              </IconContainer>
              <IconLabel>Positive Up / Negative Down</IconLabel>
            </Label>
          }
          name="trendDirectionRadio"
          value={trendDirections.UP}
          checked={value === trendDirections.UP}
          onChange={onChange}
        />
      </FormField>
      <FormField>
        <SemanticUI.Radio
          label={
            <Label>
              <IconContainer $isPositiveColor>
                <SemanticUI.Icon name="arrow down" />
              </IconContainer>
              <IconContainer>
                <SemanticUI.Icon name="arrow up" />
              </IconContainer>
              <IconLabel>Positive Down / Negative Up</IconLabel>
            </Label>
          }
          name="trendDirectionRadio"
          value={trendDirections.DOWN}
          checked={value === trendDirections.DOWN}
          onChange={onChange}
        />
      </FormField>
      <FormField>
        <SemanticUI.Radio
          label={
            <Label>
              <IconContainer $isPositiveColor>
                <SemanticUI.Icon name="arrow up" style={{ color: trendColors.up }} />
              </IconContainer>
              <IconContainer>
                <SemanticUI.Icon name="arrow down" style={{ color: trendColors.down }} />
              </IconContainer>
              <IconLabel>Custom</IconLabel>
            </Label>
          }
          name="trendDirectionRadio"
          value={trendDirections.CUSTOMTREND}
          checked={value === trendDirections.CUSTOMTREND}
          onChange={onChange}
        />
      </FormField>
    </div>
  );
};

export default TrendDirection;
export { trendDirections };
